import React from 'react';
import HeroImage from '../../../../assets/images/services/banking-license/hero-image.png'
import PageBanner from '../../../../assets/images/services/banking-license/page-banner.png'

import BreadCrumbs from "../../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../../components/Constant/List/List";
import { GiCheckMark } from "react-icons/gi";
import { GoDotFill } from "react-icons/go";
import Testimonials from "../../../../components/Constant/Testimonials/Testimonials";
import CTA from "../../../../components/Constant/cta/CTA";
import FAQList from "../../../../components/Constant/FAQCard/FAQCard";
import Button from "../../../../components/Constant/button/Button";

const BreadCrumbsData = [
    { name: 'Offshore Advisory', link: '/' },
    {
        name: 'Banking License – Seychelles',
        link: '/banking-license-seychelles',
    },
]

function BankingLicenseSeychelles () {

    return (
        <main className='main'>
            <section className='banking-license-section section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='banking-license-container container'>

                    <h1 className='section-title'>
                        Banking License – Seychelles
                    </h1>

                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>
                                Establish Domestic & Offshore Banks in a Trusted Offshore Hub
                            </h3>
                            <p className='page-paragraph'>
                                <b>Seychelles</b> is a respected <b>offshore financial center</b> that offers <b>licenses for both domestic retail banks and international (offshore) banks</b>. With its <b>favorable tax regime</b>, <b>strategic location</b>, and <b>strong FSA oversight</b>, <b>Seychelles</b> has become a <b>global destination for investors and entrepreneurs seeking to launch private or corporate banks</b>.
                            </p>
                            <PageList
                                items={[
                                    {
                                        title: "Domestic Banking",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Offshore Private Banking",
                                        icon: GiCheckMark,
                                    },
                                    {
                                        title: "Corporate Banking",
                                        icon: GiCheckMark,
                                    },
                                ]}
                            />

                            <Button
                                text="Request a Seychelles Banking Proposal  →"
                                link="/consultation"
                                type="primary"
                                size="large"
                            />
                        </div>

                        <HeroRightImage src={HeroImage} />
                    </div>

                    <BannerPageImg src={PageBanner} />
                    <b/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>Why Choose Seychelles for Banking?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Respected Regulator",
                                    paragraph: "Central Bank of Seychelles (CBS) oversight",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Dual Options",
                                    paragraph: "Local retail banks or offshore-only banks",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strategic Location",
                                    paragraph: "Gateway to Africa, Asia, and Europe",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Neutrality",
                                    paragraph: "International banks exempt from local income tax",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Balanced Regulation",
                                    paragraph: "Stricter than “light offshore” centers, but easier than EU",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Types of Banking Licenses</h3>
                        <p className='page-subtitle'>1. Domestic Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "Serve residents and local businesses in Seychelles.", icon: GoDotFill },
                                { title: "Full retail & commercial banking services:", paragraph: "Deposits, savings, loans, \tCredit card issuance, \tCorporate accounts and trade finance.", icon: GoDotFill },
                                { paragraph: "Credit card issuance.", icon: GoDotFill },
                                { paragraph: "Corporate accounts and trade finance.", icon: GoDotFill },
                                { title: 'Capital Requirement:', paragraph: "typically USD 5M+.", icon: GoDotFill },
                            ]}
                        />

                        <p className='page-subtitle'>2. International (Offshore) Banking License</p>
                        <PageList
                            items={[
                                { paragraph: "Serve non-resident individuals and corporations only.", icon: GoDotFill },
                                { title: "Services include:", paragraph: "Private & corporate accounts, Wealth management and custody, Investment banking and trade finance, Multi-currency services.", icon: GoDotFill },
                                { title: 'Capital Requirement:', paragraph: "USD 2M–5M, depending on business model.", icon: GoDotFill },
                            ]}
                        />

                        <h3 className='page-title'>Benefits of a Seychelles Banking License</h3>
                        <PageList
                            items={[
                                {
                                    title: "Global Recognition",
                                    paragraph: "Better credibility than small offshore centers",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Dual Options",
                                    paragraph: "Domestic and offshore banking licenses available",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tax Neutrality",
                                    paragraph: "International banks exempt from local tax",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Corporate Flexibility",
                                    paragraph: "Serve HNWIs, corporates, and global investors",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Strategic Hub",
                                    paragraph: "Ideal for Africa/Asia-Europe trade corridors",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Requirements</h3>
                        <PageList
                            items={[
                                {
                                    title: "Capital",
                                    paragraph: "USD 2M–5M minimum depending on the banking model",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Entity",
                                    paragraph: "Local incorporation in Seychelles required",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Directors",
                                    paragraph: "Fit and proper individuals with banking or finance background",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Resident Presence",
                                    paragraph: "Registered office and compliance officer must be based in Seychelles",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "AML/KYC Compliance",
                                    paragraph: "Aligned with international FATF standards",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Reporting",
                                    paragraph: "Audited financial statements submitted to CBS/FSA",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Licensing Process</h3>
                        <PageList
                            items={[
                                {
                                    title: "Pre-Application Consultation",
                                    paragraph: "Define the banking model — retail or offshore-only.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Company Incorporation",
                                    paragraph: "Establish a Seychelles-incorporated entity to hold the license.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Application Preparation",
                                    paragraph: "Prepare business plan, risk management framework, and AML/KYC manuals.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Regulatory Review",
                                    paragraph: "CBS and FSA conduct full due diligence on shareholders, directors, and systems.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Approval & License Issuance",
                                    paragraph: "Final approval granted within approximately 9–12 months.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Timeline & Costs</h3>
                        <PageList
                            items={[
                                {
                                    title: "Timeline",
                                    paragraph: "9–12 months depending on business model and regulatory review speed.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Setup Costs",
                                    paragraph: "From USD 150,000+ covering legal, compliance, and advisory services.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Capital Requirement",
                                    paragraph: "USD 2M–5M minimum, depending on license type and banking scope.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Annual Costs",
                                    paragraph: "Include audits, regulator fees, and ongoing compliance management.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                        <h3 className='page-title'>Why Offshore Advisory?</h3>
                        <PageList
                            items={[
                                {
                                    title: "Specialists in Offshore and Private Banking Licensing",
                                    paragraph: "Expertise across all banking models, including offshore, private, and fintech-oriented banks.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "End-to-End Support",
                                    paragraph: "Comprehensive assistance with entity setup, CBS/FSA filings, AML/KYC compliance, and documentation.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Banking & Payment Integrations",
                                    paragraph: "Introductions to core banking software providers, card issuers, and correspondent banking partners.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Tailored Structuring Guidance",
                                    paragraph: "Advisory for private banks, fintech-banks, and corporate banking frameworks to ensure regulatory alignment.",
                                    icon: GoDotFill,
                                },
                                {
                                    title: "Comparative Jurisdiction Analysis",
                                    paragraph: "Insightful comparisons of Seychelles vs Panama, St. Lucia, and Cyprus for optimal licensing strategy.",
                                    icon: GoDotFill,
                                },
                            ]}
                        />

                    </div>

                    <FAQList data={faqData} title='Frequently Asked Questions (FAQ)'/>
                    <Testimonials
                        title="Client Testimonials"
                        testimonials={testimonialsData}
                    />
                    <CTA
                        title="Looking to launch a domestic or offshore bank?"
                        description=
                            "<b>Seychelles</b> offers <b>banking licenses</b> with <b>CBS oversight</b>, combining <b>credibility</b>, <b>tax neutrality</b>, and <b>flexibility</b>."
                        buttonText="Book a Seychelles Banking License Consultation →"
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    );
}

export default BankingLicenseSeychelles;

const faqData = [
    {
        question: "What’s the capital requirement?",
        content: [
            {
                type: "list",
                items: [
                    "<strong>Domestic Banks:</strong> USD 5M+",
                    "<strong>Offshore Banks:</strong> USD 2M–5M",
                ],
            },
        ],
    },
    {
        question: "How long does licensing take?",
        content: [
            { type: "answer", text: "9–12 months." },
        ],
    },
    {
        question: "Can Seychelles offshore banks serve residents?",
        content: [
            { type: "answer", text: "No — offshore banks may only serve non-resident clients." },
        ],
    },
    {
        question: "Is Seychelles a credible banking hub?",
        content: [
            { type: "answer", text: "Yes — more respected than Mwali or Anjouan, but lighter than EU hubs." },
        ],
    },
    {
        question: "Can Seychelles banks issue debit/credit cards?",
        content: [
            { type: "answer", text: "Yes, through Visa/Mastercard partnerships." },
        ],
    },
];



const testimonialsData = [
    {
        quote:
            "We established a private offshore bank in Seychelles. Offshore Advisory handled the Central Bank process end-to-end.",
        author: "Andre M.",
        role: "Private Banker",
    },
    {
        quote:
            "Seychelles gave us a cost-effective way to launch a regional trade finance bank.",
        author: "Sophia L.",
        role: "Corporate Banking Entrepreneur",
    },
];